import { render, staticRenderFns } from "./JoinRewardsCallout.vue?vue&type=template&id=37b2ef79"
import script from "./JoinRewardsCallout.vue?vue&type=script&setup=true&lang=ts"
export * from "./JoinRewardsCallout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./JoinRewardsCallout.vue?vue&type=style&index=0&id=37b2ef79&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports